import * as z from "zod";

declare global { const locales: Locales; }

export const localeSchema = z.object({
  code: z.string().max(2),
  name: z.string(),
  url: z.string(),
});
export type Locale = z.infer<typeof localeSchema>;

export const localesSchema = z.object({
  current: localeSchema,
  available: z.array(localeSchema),
});
export type Locales = z.infer<typeof localesSchema>;
